var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"ql-snow w-full",class:_vm.data.staticClass},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.props.data)}})])}
var staticRenderFns = []

export { render, staticRenderFns }